import {
  GET_PERFORMANCE_REQUEST,
  GET_PERFORMANCE_SUCCESS,
  GET_PERFORMANCE_FAILURE,
  CLEAR_PERFORMANCE,
} from "actions/performance";

const initialState = {
  loading: false,
  error: {},
  data: [],
  dataLoaded: false,
};

export default function performance(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PERFORMANCE_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_PERFORMANCE_SUCCESS: {
      var running_cost = 0;
      var running_cost_import = 0;
      var running_cost_export = 0;
      return {
        ...state,
        loading: false,
        data: payload
          ? payload.map((it) => {
            return {
              ...it,
              price_export: it.price_export * -1,
              cost_cumulative:
                it.cost_net != null ? (running_cost += it.cost_net) : null,
              cost_import_cumulative:
                it.cost_import != null
                  ? (running_cost_import += it.cost_import)
                  : null,
              cost_export_cumulative:
                it.cost_export != null
                  ? (running_cost_export += it.cost_export)
                  : null,
            };
          })
          : [],
        dataLoaded: true,
      };
    }

    case GET_PERFORMANCE_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case CLEAR_PERFORMANCE: {
      return {
        ...state,
        loading: false,
        data: [],
        dataLoaded: false,
      };
    }

    default:
      return state;
  }
}
